import { useState } from "react";
import { PartyPopper, Rocket, Undo2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

export const PublishControls = ({ bookId, published, onChange, onCelebrate }) => {
  const [busy, setBusy] = useState(false);
  const set = async (val) => {
    setBusy(true);
    try {
      const { data } = await api.post(`/books/${bookId}/publish`, { published: val });
      onChange(val);
      if (data.celebration) onCelebrate(data.celebration); else toast.success("Moved back to draft");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  const showCard = async () => { try { onCelebrate((await api.get(`/books/${bookId}/celebration`)).data); } catch (e) { toast.error(errMsg(e)); } };
  if (!published) return (
    <button type="button" disabled={busy} onClick={() => set(true)} data-testid="mark-published-btn"
      className="inline-flex items-center gap-1.5 h-8 px-3 rounded-full text-xs bg-emerald-700 hover:bg-emerald-600 text-white transition-colors disabled:opacity-60"><Rocket size={13} />Mark as published</button>
  );
  return (
    <div className="flex items-center gap-2" data-testid="published-controls">
      <span className="inline-flex items-center gap-1 text-[11px] font-mono uppercase tracking-wider px-2 py-0.5 rounded-md border border-emerald-500/40 text-emerald-300 bg-emerald-500/10" data-testid="published-badge">Published</span>
      <button type="button" onClick={showCard} className="inline-flex items-center gap-1 text-xs text-amber-300 hover:underline" data-testid="show-share-card-btn"><PartyPopper size={13} />Share card</button>
      <button type="button" disabled={busy} onClick={() => set(false)} className="inline-flex items-center gap-1 text-xs text-slate-500 hover:text-slate-300" data-testid="unpublish-btn"><Undo2 size={12} />Back to draft</button>
    </div>
  );
};
